export const easyCompliance = {
  apiKey: "API Key",
  apiKeyHelp:
    "Unique key for authentication. Provided to you by customer service. Access to the API is not possible without an API key."
};
